import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";
import ButtonComponent from './ButtonComponent.jsx';

const DiscardChanges = ({ cancelClick, discardClick, title = "" }) => {
  const handleCancelClick = useCallback(() => {
    cancelClick();
  }, [cancelClick]);

  const handleDiscardClick = useCallback(() => {
    discardClick();
  }, [discardClick]);

  return (
    <>
      <h4 className="delete-h">Discard Changes</h4>
      {title === "add" ? (
        <p>
          Are you sure you want to cancel this new entry? Any unsaved data will
          be lost.
        </p>
      ) : title === "reorder" ? (
        <p>
          Are you sure you want to discard the priority order changes? Any unsaved changes will be lost.
        </p>
      ) : (
        <p>
          Are you sure you want to cancel editing this entry? Any unsaved
          changes will be lost.
        </p>
      )}
      <div className="btnswrap btn-dlt">
        <ButtonComponent
          text="No"
          className="cancelBtnStyle btn btn-primary"
          onClick={handleCancelClick}
        />
        <ButtonComponent
          text="Yes"
          className="btnStyle btn btn-primary"
          onClick={handleDiscardClick}
        />
      </div>
    </>
  );
};

DiscardChanges.propTypes = {
  cancelClick: PropTypes.func.isRequired,
  discardClick: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default memo(DiscardChanges);



